<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7742_23712)">
     <path d="M5.72667 9.84716L10.28 12.5005M10.2733 5.18049L5.72667 7.83383M14 4.17383C14 5.2784 13.1046 6.17383 12 6.17383C10.8954 6.17383 10 5.2784 10 4.17383C10 3.06926 10.8954 2.17383 12 2.17383C13.1046 2.17383 14 3.06926 14 4.17383ZM6 8.84049C6 9.94506 5.10457 10.8405 4 10.8405C2.89543 10.8405 2 9.94506 2 8.84049C2 7.73593 2.89543 6.84049 4 6.84049C5.10457 6.84049 6 7.73593 6 8.84049ZM14 13.5072C14 14.6117 13.1046 15.5072 12 15.5072C10.8954 15.5072 10 14.6117 10 13.5072C10 12.4026 10.8954 11.5072 12 11.5072C13.1046 11.5072 14 12.4026 14 13.5072Z" stroke="#ECEBEB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_7742_23712">
        <rect width="16" height="16" fill="white" transform="translate(0 0.839844)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#FFFFFF',
    },
  },
}
</script>
